import { Instance } from 'mobx-state-tree';
import { CustomerProfileDtoEdgeModelBase } from './CustomerProfileDtoEdgeModel.base';

/* The TypeScript type of an instance of CustomerProfileDtoEdgeModel */
export interface CustomerProfileDtoEdgeModelType extends Instance<typeof CustomerProfileDtoEdgeModel.Type> {}

/* A graphql query fragment builders for CustomerProfileDtoEdgeModel */
export { selectFromCustomerProfileDtoEdge, customerProfileDtoEdgeModelPrimitives, CustomerProfileDtoEdgeModelSelector } from './CustomerProfileDtoEdgeModel.base';

/**
 * CustomerProfileDtoEdgeModel
 */
export const CustomerProfileDtoEdgeModel = CustomerProfileDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
